import { render, staticRenderFns } from "./TkHotelPlanItem.vue?vue&type=template&id=074f60bb&scoped=true&"
import script from "./TkHotelPlanItem.vue?vue&type=script&lang=js&"
export * from "./TkHotelPlanItem.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelPlanItem.vue?vue&type=style&index=0&id=074f60bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f60bb",
  null
  
)

export default component.exports